
import { defineComponent,onMounted,ref,reactive,toRef} from 'vue';
import axios from 'axios';
import {message} from "ant-design-vue";
import {Tool} from "@/util/tool";
import TheWelcome from "@/components/the-welcome.vue";

export default defineComponent({
  name: 'Home',
  components: {
    TheWelcome,
  },
  setup(){
    console.log("setup");
    const ebooks = ref();
    // const ebooks1 = reactive({books:[]});
    const level1 = ref(); //一级分类树，children属性就是二级分类
    let categorys:any;
    /**
     * 查询所有分类
     **/
    const handleQueryCategory = () => {
      axios.get("/category/all").then((response) => {
        const data = response.data;
        if(data.success){
          categorys = data.content;
          console.log("原始数组：",categorys);
          level1.value = [];
          level1.value = Tool.array2Tree(categorys,0);
          console.log("树形结构：",level1);
        }else {
          message.error(data.message);
        }
      });
    };

    const handleQueryEbook = ()=>{
      axios.get("/ebook/list",{
        params:{
          page:1,
          size:ebook_num,
          categoryId2:categoryId2,
        }
      })
          .then((response)=> {
            const data = response.data;
            ebooks.value = data.content.list;
          });
    }

    const isShowWelcome = ref(true);
    let categoryId2 = 0;

    const handleClick = (value:any)=>{
      // console.log("菜单点击");
      if(value.key === 'welcome'){
        window.location.reload();
        isShowWelcome.value = true;
      }else{
        categoryId2 = value.key;
        isShowWelcome.value = false;
        handleQueryEbook();
      }
      // 简化如下：
      // isShowWelcome.value = value.key === 'welcome';
    };

    const ebook_num = 1000;
    //页面初始时调用
    onMounted(()=>{
      handleQueryCategory();
    });

    return{
      ebooks,
      // ebooks2:toRef(ebooks1,"books"),
      //分页功能
      pagination : {
        onChange: (page: any) => {
          console.log(page);
        },
        pageSize: 6,
      },
    //   actions:  [
    //   { type: 'StarOutlined', text: '156' },
    //   { type: 'LikeOutlined', text: '156' },
    //   { type: 'MessageOutlined', text: '2' },
    // ],
     handleClick,
      level1,
      isShowWelcome,
    }
  }
});
